var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanningDocIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.734,
    height: 83.806,
    viewBox: "0 0 83.734 83.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bce0fd;}.b{fill:#694b4b;}.c{fill:#f6d2bf;}.d{fill:#1a8cff;}.e{fill:#0063f6;}.f{fill:#013272;}.g{fill:#013b88;}.h{fill:#00429a;}.i,.n{fill:#fc6fd0;}.j{fill:#f0c3ab;}.k{fill:#fc98dd;}.l{fill:#f7ded0;}.m{fill:#61b5fc;}.n{opacity:0.75;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.553 19.742)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,41.849A41.849,41.849,0,1,0,41.849,0,41.854,41.854,0,0,0,0,41.849Z",
    transform: "translate(-19.553 -19.742)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.723 0.914)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M69.019,260.673c-10.988,0-9.769,13.363-9.719,23.047a1.034,1.034,0,0,0,.507.884,18.544,18.544,0,0,0,18.425,0,1.034,1.034,0,0,0,.507-.884C78.789,274.036,80.007,260.673,69.019,260.673Z",
    transform: "translate(-53.678 -251.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.461,313.655l.431,4.091a2.777,2.777,0,0,0,1.417,2.176l3.953,2.2a2.073,2.073,0,0,0,1.413.211h0s-1.993-.6-3.179-3.815c-.363-.983-.868-6.19-.434-6.827.857-1.258,5.64-1.389,7.053-3.722q-.1-.13-.193-.26l-.015-.021a2.674,2.674,0,0,1-.164-.278C88.273,310.878,81.461,308.1,81.461,313.655Z",
    transform: "translate(-72.931 -292.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M79.021,236.694H20.015a2.36,2.36,0,0,1-2.36-2.36V196.567a2.36,2.36,0,0,1,2.36-2.36H79.021a2.36,2.36,0,0,1,2.36,2.36v37.767A2.36,2.36,0,0,1,79.021,236.694Z",
    transform: "translate(-17.655 -194.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M66.56,271.39H45.318a1.18,1.18,0,0,1-1.18-1.18V239.524a1.18,1.18,0,0,1,1.18-1.18H66.56a1.18,1.18,0,0,1,1.18,1.18V270.21A1.18,1.18,0,0,1,66.56,271.39Z",
    transform: "translate(-40.598 -232.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M68.316,260.879c-10.219.573-9.06,13.551-9.011,23.019a1.034,1.034,0,0,0,.507.884,18.21,18.21,0,0,0,9.213,2.45L71.8,267.794",
    transform: "translate(-53.682 -251.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M89.116,260.673c-6.248,0-6.682,7.55-6.682,7.55,3.6-.608,5.814.911,9.458-.608l-2.777,19.439a18.21,18.21,0,0,0,9.213-2.45,1.034,1.034,0,0,0,.507-.884C98.885,274.036,100.1,260.673,89.116,260.673Z",
    transform: "translate(-73.774 -251.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M166.779,288.607c.043-8.321.941-19.351-5.776-22.292a6.169,6.169,0,0,0,.222,3.411c1.388,2.777,2.777,2.777,4.165,4.86,1.388,7.637-2.653,15.742-4,16.845h0a17.462,17.462,0,0,0,4.877-1.94A1.035,1.035,0,0,0,166.779,288.607Z",
    transform: "translate(-141.718 -256.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.459,412.908l-6.194-2.581a1.389,1.389,0,0,1-.854-1.282v-1.678H52.468v1.678a1.388,1.388,0,0,1-.854,1.282l-6.194,2.581a2.083,2.083,0,0,0-1.282,1.923v1.805a1.18,1.18,0,0,0,1.18,1.18H66.56a1.18,1.18,0,0,0,1.18-1.18v-1.805A2.083,2.083,0,0,0,66.459,412.908Z",
    transform: "translate(-40.598 -378.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M66.459,432.638l-5.989-2.5-4.53,1.956-4.53-1.956-5.989,2.5a2.083,2.083,0,0,0-1.282,1.922v1.805a1.18,1.18,0,0,0,1.18,1.18H66.56a1.18,1.18,0,0,0,1.18-1.18V434.56A2.083,2.083,0,0,0,66.459,432.638Z",
    transform: "translate(-40.598 -398.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M101.588,407.367H94.646v1.678a1.388,1.388,0,0,1-.854,1.282l-.967.4C100.227,412.617,101.588,407.367,101.588,407.367Z",
    transform: "translate(-82.775 -378.869)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.54 30.408)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M47.522,454.535l-2.786-2.217a2.079,2.079,0,0,0-.6,1.454v1.8a1.18,1.18,0,0,0,1.18,1.18H48.3v-.6A2.07,2.07,0,0,0,47.522,454.535Z",
    transform: "translate(-44.138 -448.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M193.7,455.633v-1.805a2.078,2.078,0,0,0-.588-1.445l-2.8,2.208a2.083,2.083,0,0,0-.782,1.626v.6h2.985A1.18,1.18,0,0,0,193.7,455.633Z",
    transform: "translate(-170.098 -448.274)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M128.019,449.046h-.208a.59.59,0,0,1-.59-.59V444.78h1.388v3.676A.59.59,0,0,1,128.019,449.046Z",
    transform: "translate(-116.114 -441.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M96.426,424.738l-3.973-2.98a.555.555,0,0,0-.8.136l-.785,1.178,2.436,3.411a.555.555,0,0,0,.8.111Z",
    transform: "translate(-84.624 -421.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M132.414,424.738l3.973-2.98a.555.555,0,0,1,.8.136l.785,1.178-2.436,3.411a.555.555,0,0,1-.8.111Z",
    transform: "translate(-120.613 -421.647)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M91.743,307.407c-3.471,3.471-10.283.694-10.283,6.248l.431,4.091a2.777,2.777,0,0,0,1.417,2.176l3.953,2.2a2.082,2.082,0,0,0,2.023,0l3.953-2.2a2.777,2.777,0,0,0,1.417-2.176l.5-4.859a7.665,7.665,0,0,0,.031-1.039C94.922,310.081,92.437,308.8,91.743,307.407Z",
    transform: "translate(-72.93 -292.273)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.863 8.261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M276.062,258.36H257.18a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h18.882a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,276.062,258.36Z",
    transform: "translate(-256 -255.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M281.963,293.671H257.18a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h24.782a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,281.963,293.671Z",
    transform: "translate(-256 -286.589)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M259.54,373.119h-2.36a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h2.36a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.54,373.119Z",
    transform: "translate(-256 -355.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M324.307,373.119H310.145a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h14.161a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,324.307,373.119Z",
    transform: "translate(-301.884 -355.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M259.54,408.429h-2.36a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h2.36a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.54,408.429Z",
    transform: "translate(-256 -386.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M327.847,408.429h-17.7a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h17.7a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,327.847,408.429Z",
    transform: "translate(-301.884 -386.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M259.54,443.739h-2.36a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h2.36a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.54,443.739Z",
    transform: "translate(-256 -416.594)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.081 24.784)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M319.586,443.739h-9.441a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h9.441a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,319.586,443.739Z",
    transform: "translate(-308.965 -441.378)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.461,313.655l.431,4.091a2.777,2.777,0,0,0,1.417,2.176l3.953,2.2a2.073,2.073,0,0,0,1.413.211h0s-1.993-.6-3.179-3.815c-.363-.983-.868-6.19-.434-6.827.857-1.258,5.64-1.389,7.053-3.722q-.1-.13-.193-.26l-.015-.021a2.674,2.674,0,0,1-.164-.278C88.273,310.878,81.461,308.1,81.461,313.655Z",
    transform: "translate(-72.931 -292.272)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M0,0,82.807,0a46.1,46.1,0,0,1-4.68,14.412A52.051,52.051,0,0,1,68.109,26.533,41.235,41.235,0,0,1,42.07,36.189a44.918,44.918,0,0,1-26.762-9.078S8.6,21.338,4.771,14.561A44.5,44.5,0,0,1,0,0Z",
    transform: "translate(-19.079 27.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-.473-.039,83.26,0s-.017,1.479-.146,3.229-.428,3.77-.428,3.77L.068,7S-.22,5.007-.355,3.248-.473-.039-.473-.039Z",
    transform: "translate(-19.079 21.874)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanningDocIcn);
export default __webpack_public_path__ + "static/media/scanning_doc_icn.625d2a5d0cd12ddd5f6ff063003ac9d3.svg";
export { ForwardRef as ReactComponent };